module.exports = __webpack_public_path__ + "static/media/YF77_2.4b15a2be.jpg";